import styled, { css, DefaultTheme } from 'styled-components';

type ButtonProps = {
  fullWidth?: boolean;
  format: 'primary' | 'secondary';
  isProcessing?: boolean;
  isSuccess?: boolean;
};

const WrapperModifiers = {
  fullWidth: () => css`
    max-width: 100%;
  `,
  primary: (theme: DefaultTheme) => css`
    border: none;
    background-color: ${theme.colors.purple100};
    color: ${theme.colors.globalWhite100};
  `,
  secondary: (theme: DefaultTheme) => css`
    border: 1px solid ${theme.colors.purple80};
    background-color: ${theme.colors.globalWhite100};
    color: ${theme.colors.purple80};
  `,
  disabled: (theme: DefaultTheme) => css`
    background: ${theme.colors.neutralSilver50};
    border: 1px solid ${theme.colors.neutralSilver50};
    cursor: not-allowed;
  `,
  processing: (theme: DefaultTheme) => css`
    background: ${theme.colors.primary20};
    border: 1px solid ${theme.colors.primary10};
    color: ${theme.colors.primary100};
    cursor: not-allowed;
  `,
  success: (theme: DefaultTheme) => css`
    background: ${theme.colors.statusSuccess10};
    border: 1px solid ${theme.colors.statusSuccess10};
    color: ${theme.colors.statusSuccess50};
  `,
};

export const Wrapper = styled.button<ButtonProps>`
  ${({ theme, fullWidth, format, disabled, isProcessing, isSuccess }) => css`
    background-color: ${theme.colors.purple100};
    border-radius: 4px;
    border: none;
    color: ${theme.colors.globalWhite100};
    padding: 12px;
    width: 100%;
    max-width: 298px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    text-decoration: none;

    ${format && WrapperModifiers[format](theme)}
    ${disabled && WrapperModifiers.disabled(theme)}
    ${isProcessing && WrapperModifiers.processing(theme)}
    ${isSuccess && WrapperModifiers.success(theme)}
    ${fullWidth && WrapperModifiers.fullWidth()}

    > span {
      display: flex;
      font-size: 1.8rem;
      font-weight: 700;
    }
  `}
`;
